import React from "react";
import styled from "styled-components";
import colors from "../../../utils/colors";
import colorThemes from "../../../ui/colorThemes";
import { rem } from "polished";
import PropTypes from "prop-types";
import { media } from "../../../utils/uiSizes";

const ContentWrap = styled.div`
  width: 100%;
  padding: ${rem("18px")} ${rem("24px")};
  ${media.tablet`
		width: ${props => (props.half ? "calc(50% - 0.625rem)" : "100%")};
  	padding: ${props => (props.tight ? "1.5rem 1.75rem" : "2.25rem 3rem")};
  `}

  box-sizing: border-box;
  background: ${colors.WHITE};
	box-shadow: 1px 3px 10px 0 rgba(0,0,0,0.20);
	border-radius: ${rem("5px")};

	margin-bottom: 1.25rem;
	position: relative;

	${props =>
    props.nopaddingv &&
    `
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	`};

	${props =>
    props.theme &&
    props.theme === colorThemes.DARK &&
    `
		color: ${colors.WHITE};
		background: ${colors.GRAY_DARKER};
	`}

	${props =>
    props.theme &&
    props.theme === colorThemes.TRANSPARENT &&
    `
		background: ${colors.TRANSPARENT};
		box-shadow: none;
	`}
	h2 {
		font-weight:400;
	}
	${props =>
    props.center &&
    `
		h2 {
			text-align: center;
			margin: auto;
		}
	`}

	> header {
		display: block;
		${media.tablet`
			display: flex;
			justify-content: space-between;
			align-items: center;
		`}
    line-height: 2rem;
		margin-bottom: 1.5rem;

		button {
			margin-left: 1em;
		}
	}

	> footer {
		margin-top: 1rem;
	}

	button {
		margin-top: 1rem;
		${media.tablet`
			margin-top: 0;
		`}
	}
`;

const ContentBlock = props => {
  const { title, renderActions, children, ...rest } = props;
  return (
    <ContentWrap {...rest}>
      {(title || renderActions) && (
        <header>
          {title && <h2>{title}</h2>}
          {renderActions && renderActions()}
        </header>
      )}
      {children}
    </ContentWrap>
  );
};

ContentBlock.propTypes = {
  theme: PropTypes.string,
  half: PropTypes.bool,
  center: PropTypes.bool,
  renderActions: PropTypes.func,
  nopaddingv: PropTypes.bool
};

ContentBlock.defaultProps = {
  theme: colorThemes.LIGHT,
  half: false,
  center: false,
  nopaddingv: false,
  renderActions: null
};

export default ContentBlock;



// WEBPACK FOOTER //
// ./src/modules/pages/components/ContentBlock.js